import { AuthContext } from "@/contexts";
import { Button, Flex, Image, Img, Link, Stack, Text } from "@chakra-ui/react";
import Router from "next/router";
import { useContext } from "react";

export function MenuConnected({ name, onClose }) {
  const { signOut } = useContext(AuthContext);
  return (
    // <Stack spacing="11px" color="gray.300">
    //   <Flex borderBottom="2px" paddingBottom="15px" textColor={"#A9A9A9"}>
    //     <Text textColor={"#58585A"} mr="5px">
    //       Olá
    //     </Text>
    //     <Text textStyle="Bold" textColor="#1E1E1E">
    //       {name}
    //     </Text>
    //   </Flex>

    //   <Link
    //     // _hover={{ textDecoratiom: "none" }}
    //     display="flex"
    //     onClick={() => {
    //       onClose();
    //       Router.push("/minhaconta");
    //     }}
    //     textColor={"#A9A9A9"}
    //     borderBottom="2px"
    //     paddingBottom="15px"
    //     _hover={{ textStyle: "Bold" }}
    //   >
    //     <Image
    //       src="/icons/geral/user-blank.svg"
    //       alt="user"
    //       mr="10px"
    //       w={"18px"}
    //     />
    //     <Text marginLeft="10px" textColor={"#58585A"} fontSize="14px">
    //       MINHA CONTA
    //     </Text>
    //   </Link>

    //   <Link
    //     // _hover={{ textDecoration: "none" }}
    //     onClick={() => {
    //       onClose();
    //       Router.push("/minhaconta/enderecos");
    //     }}
    //     display="flex"
    //     borderBottom="2px"
    //     color={"#A9A9A9"}
    //     alignItems="center"
    //     paddingBottom="15px"
    //     _hover={{ textStyle: "Bold" }}
    //   >
    //     <Image
    //       src="/icons/geral/pointer-blank.svg"
    //       alt="endereços"
    //       mr="10px"
    //       w={"18px"}
    //     />
    //     <Text marginLeft="10px" textColor={"#58585A"} fontSize="14px">
    //       ENDEREÇOS
    //     </Text>
    //   </Link>

    //   <Link
    //     display="flex"
    //     onClick={() => {
    //       onClose();
    //       Router.push("/minhaconta/pedidos");
    //     }}
    //     borderBottom="2px"
    //     alignItems="center"
    //     paddingBottom="15px"
    //     textColor={"#A9A9A9"}
    //     _hover={{ textStyle: "Bold" }}
    //   >
    //     <Image
    //       src="/icons/geral/clipboard-blank.svg"
    //       alt="Pedidos"
    //       mr="10px"
    //       w={"18px"}
    //     />
    //     <Text marginLeft="10px" textColor={"#58585A"} fontSize="14px">
    //       PEDIDOS
    //     </Text>
    //   </Link>
    //   <Link
    //     display="none"
    //     href="/minhaconta/"
    //     borderBottom="2px"
    //     alignItems="center"
    //     paddingBottom="15px"
    //     //passHref
    //   >
    //     <Image src="/icons/geral/car-blank.svg" alt="garagem" mr="10px" />
    //     <Text marginLeft="10px">GARAGEM</Text>
    //   </Link>
    //   <Button
    //     textStyle="Bold"
    //     _hover={{ bgColor: "#FF003A" }}
    //     background="#1E1E1E"
    //     color="white"
    //     borderRadius="5px"
    //     top="10px"
    //     fontSize="text1"
    //     h="40px"
    //     onClick={() => {
    //       signOut();
    //       Router.push("/");
    //     }}
    //   >
    //     ENCERRAR SESSÃO
    //   </Button>
    // </Stack>
    <Flex flexDir={"column"} w={"full"} minH={"100px"}>
      <Button
        justifyContent={"flex-start"}
        bgColor={"ll-white.main"}
        borderTop={"1px solid #ECECEC"}
        onClick={() => {
          onClose();
          Router.push("/minhaconta");
        }}
      >
        <Img
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/user.svg"}
          mr={"15px"}
        />
        <Text fontSize={"h4"}>Minha conta</Text>
      </Button>
      <Button
        justifyContent={"flex-start"}
        bgColor={"ll-white.main"}
        borderTop={"1px solid #ECECEC"}
        onClick={() => {
          onClose();
          Router.push("/minhaconta/enderecos");
        }}
      >
        <Img
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/fine.svg"}
          mr={"15px"}
        />
        <Text fontSize={"h4"}>Endereços de entrega</Text>
      </Button>
      <Button
        justifyContent={"flex-start"}
        bgColor={"ll-white.main"}
        borderTop={"1px solid #ECECEC"}
        borderBottom={"1px solid #ECECEC"}
        onClick={() => {
          onClose();
          Router.push("/minhaconta/pedidos");
        }}
      >
        <Img
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/book.svg"}
          mr={"15px"}
        />
        <Text fontSize={"h4"}>Meus pedidos</Text>
      </Button>
    </Flex>
  );
}
